import styled from 'styled-components';

export const NotFoundStyles = styled.div`
margin-top: 100px;
margin-bottom: 100px;

h3{
    color: #2b2b2b;
    text-shadow: 0.2px 0.2px #2b2b2b;
    font-weight: 400;
}

.link-color{
    background-color: #00a651;
    color: white;

    &:hover {
        background-color: #008f46;
        color: white;
    }
}

.lottie-width{
    width: 30%;
}

@media screen and (max-width: 768px) {
    .lottie-width {
        width: 100%;
    }
    
}

@media (min-width: 769px) and (max-width: 1200px) {
    .lottie-width {
        width: 40%;
    }
    
}

`;
